import { axiosAhplusInstance } from "./axios";
import { AhPlusOffersRest } from "./model/AhPlusOffersRest";

const fetchOffers = async (): Promise<AhPlusOffersRest> => {
  const response = await axiosAhplusInstance.get("/api/v2/offers");

  return AhPlusOffersRest.fromJson(response.data);
};

const ahplusOffersApi = {
  fetchOffers,
};

export default ahplusOffersApi;
